<script setup lang="ts">
import {scaleValues} from "@/store/bt";
import {useI18n} from "vue-i18n";
import {computed, defineProps} from "vue";
import type {Hierarchy} from "#/BTNode";
import BtTriangle203 from "@/icons/BtTriangle-203.vue"
import BtTriangle205 from "@/icons/BtTriangle-205.vue"
import BtTriangle211 from "@/icons/BtTriangle-211.vue"

const {t} = useI18n()

const props = defineProps<{ nodes: Hierarchy[] }>();

const triangleShouldDisplay = document.querySelector('article.node--type-nwrm.node--view-mode-full') !== null

const id = computed(() => {
  const id = props.nodes[0].id
  if (id) {
    return id
  }
  return null
})

</script>

<template>
  <template v-if="triangleShouldDisplay">
    <component v-if="id === 203" :is="BtTriangle203"/>
    <component v-if="id === 205" :is="BtTriangle205"/>
    <component v-if="id === 211" :is="BtTriangle211"/>
  </template>
  <table>
    <caption>{{ t('epb.bt.table.caption') }}</caption>
    <tr v-for="obj in scaleValues">
      <td :class="obj.class">&nbsp;</td>
      <td>{{ t(obj.label) }}</td>
    </tr>
  </table>
</template>

<style scoped>
table {
  max-width: 300px;
  margin: 0 auto;
  font-size: x-small;

  caption {
    background-color: white;
    caption-side: top;
    text-align: center;
    border-top: 1px solid darkgrey;
    border-left: 1px solid darkgrey;
    border-right: 1px solid darkgrey;
  }

  tr {
    td {
      border: 1px solid darkgrey;
      width: 50%;

      &.none {
        background-color: #efefef;
      }

      &:last-child {
        background-color: white;
        border-left: none;
      }
    }
  }
}

</style>
